import { render, staticRenderFns } from "./newEditUser.vue?vue&type=template&id=e72c3b92"
import script from "./newEditUser.vue?vue&type=script&lang=js"
export * from "./newEditUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports